/**
 * Utility functions for user role presentation and mappings.
 * Maps backend internal role names / IDs to clean user-friendly labels in the frontend:
 * - Super Organization Admin (Role ID 2) -> "Organization Admin"
 * - Organization Admin (Role ID 3) -> "Organization Staff"
 * - Super Admin (Role ID 1) -> "Super Admin"
 * - App User (Role ID 4) -> "App User"
 * - Group Admin (Role ID 5) -> "Group Admin"
 * - Group Member (Role ID 6) -> "Group Member"
 */

export const getDisplayRoleName = (role, roleId) => {
  if (role === null || role === undefined) return '';

  let id = '';
  let name = '';

  if (typeof role === 'object') {
    id = role.id !== undefined ? String(role.id) : (role.role_id !== undefined ? String(role.role_id) : '');
    name = (role.role || role.role_name || role.name || '').trim();
  } else if (!isNaN(role) && String(role).trim() !== '') {
    id = String(role).trim();
  } else if (typeof role === 'string') {
    name = role.trim();
  }

  if (roleId !== undefined && roleId !== null) {
    id = String(roleId).trim();
  }

  const nameLower = name.toLowerCase();

  // Role 2: Super Organization Admin -> Display as "Organization Admin"
  if (id === '2' || nameLower === 'super organization admin') {
    return 'Organization Admin';
  }

  // Role 3: Organization Admin -> Display as "Organization Staff"
  if (id === '3' || nameLower === 'organization staff' || (nameLower === 'organization admin' && id !== '2')) {
    return 'Organization Staff';
  }

  // Role 1: Super Admin
  if (id === '1' || nameLower === 'super admin') {
    return 'Super Admin';
  }

  // Role 4: App User
  if (id === '4' || nameLower === 'app user' || nameLower === 'user') {
    return 'App User';
  }

  // Role 5: Group Admin
  if (id === '5' || nameLower === 'group admin') {
    return 'Group Admin';
  }

  // Role 6: Group Member
  if (id === '6' || nameLower === 'group member') {
    return 'Group Member';
  }

  return name || (id ? `Role ${id}` : '');
};
